<template>
  <el-dialog
    :visible.sync="internalVisible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="login-register-dialog"
    @closed="handleClosed"
  >
    <div class="dialog-title">
      {{ isLogin ? '密码登录' : '注册' }}
    </div>

    <!-- 登录 -->
    <el-form
      v-if="isLogin"
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="form-content"
    >
      <el-form-item prop="phone">
        <el-input v-model="loginForm.phone" placeholder="请输入您的手机号">
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/phone.png" alt="">
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="请输入密码"
          show-password
        >
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/pwd.png" alt="">
          </template>
        </el-input>
      </el-form-item>
      <el-button type="primary" class="submit-btn" @click="handleLogin">立即登录</el-button>
      <div class="form-footer">
        <div class="no-account">没有账号？ <span class="link" @click="switchMode('register')">立即注册</span></div>
        <div class="tac mt20" style="color: #aaaaaa;">忘记密码无法登录？请联系景区客服进行处理</div>
      </div>
    </el-form>

    <!-- 注册 -->
    <el-form
      v-else
      ref="registerForm"
      :model="registerForm"
      :rules="registerRules"
      class="form-content"
    >
      <el-form-item prop="phone">
        <el-input v-model="registerForm.phone" placeholder="请输入您的手机号">
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/phone.png" alt="">
          </template>
        </el-input>
      </el-form-item>
      
      <el-form-item prop="certificateNo">
        <el-input v-model="registerForm.certificateNo" placeholder="请输入您的身份证号">
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/idCard.png" alt="">
          </template>
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          v-model="registerForm.password"
          type="password"
          placeholder="请输入密码"
          show-password
        >
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/pwd.png" alt="">
          </template>
        </el-input>
      </el-form-item>

      <el-form-item prop="confirmPassword">
        <el-input
          v-model="registerForm.confirmPassword"
          type="password"
          placeholder="请再次输入密码"
          show-password
        >
          <template #prefix>
            <img class="prefix-img" src="@/assets/images/login/check-pwd.png" alt="">
          </template>
        </el-input>
      </el-form-item>

      <el-button type="primary" class="submit-btn" @click="handleRegister">立即注册</el-button>
      <div class="form-footer">
        <div class="no-account">已有账号？ <span class="link" @click="switchMode('login')">立即登录</span></div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { login, register } from '@/api/user'
import { mapState } from 'vuex'
import cache from '@/utils/cache'

export default {
  name: 'LoginRegisterDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      mode: 'login', // 'login' or 'register'
      loginForm: {
        phone: '',
        password: ''
      },
      registerForm: {
        phone: '',
        certificateNo: '',
        password: '',
        confirmPassword: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        certificateNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码长度不能小于8位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // ...mapState('common', ['orgId']),
    orgId(){
      return process.env.VUE_APP_ORG_ID
    },
    internalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isLogin() {
      return this.mode === 'login'
    }
  },
  methods: {
    switchMode(mode) {
      this.mode = mode
      this.$nextTick(() => {
        this.$refs.loginForm?.clearValidate()
        this.$refs.registerForm?.clearValidate()
      })
    },
    handleClosed() {
      this.mode = 'login'
      this.loginForm = { phone: '', password: '' }
      this.registerForm = { phone: '', certificateNo: '', password: '', confirmPassword: '' }
      this.$refs.loginForm?.resetFields()
      this.$refs.registerForm?.resetFields()
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          try {
            const res = await login({
              username: this.loginForm.phone,
              password: this.loginForm.password,
              orgId: this.orgId
            })
            if (res.code === 0) {
              this.$message.success('登录成功')
              this.$store.commit('user/setToken', res.data.token)
              cache.setCache('token', res.data.token)
              this.$store.dispatch('user/getUserInfo')
              this.$emit('login-success')
              this.internalVisible = false
            } else {
              this.$message.error(res.msg || res.error || '登录失败')
            }
          } catch (e) {
            console.error(e)
            this.$message.error('登录异常')
          }
        }
      })
    },
    handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (valid) {
          try {
            const res = await register({
              phone: this.registerForm.phone,
              certificateNo: this.registerForm.certificateNo,
              pwd: this.registerForm.password,
              confirmPwd: this.registerForm.confirmPassword,
              orgId: this.orgId
            })
            if (res.code === 0) {
              this.$message.success('注册成功，请登录')
              this.switchMode('login')
            } else {
              this.$message.error(res.msg || res.error || '注册失败')
            }
          } catch (e) {
            console.error(e)
            this.$message.error('注册异常')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  color: #5EA877;
  margin-bottom: 30px;
  position: relative;
}

.form-content {
  padding: 0 30px;
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
  height: 44px;
  font-size: 16px;
}

.form-footer {
  margin-top: 15px;
  
  .no-account {
    font-size: 14px;
    color: #666;
    
    .link {
      color: #5EA877;
      cursor: pointer;
      margin-left: 5px;
    }
  }
}

::v-deep .el-input__prefix {
  left: 5px;
}
</style>

<style lang="scss">
.login-register-dialog{
  border-radius: 16px!important;
  .el-dialog__body {
    padding: 10px 20px 30px;
  }
}

.el-input__prefix {
  .prefix-img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
